import { render, staticRenderFns } from "./CotacaoDetalhesCardDetails.vue?vue&type=template&id=5164ad24"
import script from "./CotacaoDetalhesCardDetails.vue?vue&type=script&lang=js"
export * from "./CotacaoDetalhesCardDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports